module.exports = __webpack_public_path__ + "static/img/join_10.dcf2e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_10.jpg
// module id = dNNs
// module chunks = 1